import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { FormInput, FormTextBoxPassword, FormSwitch, FormNumericTextBox, FormDropDownList } from '../FormComponents'
import {
  requiredValidator,
  emailValidator,
  passwordValidator,
} from '../Validators'
import { useState, useEffect } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { getEmployeeTypes } from '../../../data/userData'
import { dropDown } from '../../../data/interfaces'
import { ApiErrorDetails } from '../../../helpers/apiError'

// ✅ Add mobile phone validator
const mobilePhoneValidator = (value: string) =>
  value && /^\+?[0-9]{7,15}$/.test(value)
    ? ''
    : 'Enter a valid mobile phone number'

const AddUserForm = (props: any) => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [passLabel, setPassLabel] = useState('')
  const [passMatch, setPassMatch] = useState(true)
  const [allowSubmit, setAllowSubmit] = useState(true)
  const [subcontractorValue, setSubcontractorValue] = useState(false);

  const handleSwitchContractor = (e: any) => {
    setSubcontractorValue(e.value)
  }



  const handlePasswordMatch = () => {
    if (password !== confirmPassword) {
      setPassLabel('Passwords do not match')
      setPassMatch(false)
      setAllowSubmit(false)
    } else {
      setPassLabel('')
      setPassMatch(true)
      setAllowSubmit(true)
    }
  }

  useEffect(() => {
    handlePasswordMatch()
  }, [confirmPassword, password])


  /** Employee type */
  const [employeeTypes, setEmployeeTypes] = useState<dropDown[]>([]);
  const [selectedEmplpyeeType, setSelectedEmployeeType] = useState(0);

  const getAndStoreEmployeeTypes = async () => {
    const res = await getEmployeeTypes();
    setEmployeeTypes(
      res.map((item: any) => {
        return {
          text: item.text,
          value: Number(item.value),
        }
      })
    )
  }

  useEffect(() => {
    getAndStoreEmployeeTypes()
  }, [])
  /** end Employee type */

  const error: ApiErrorDetails | null = props.error ?? null

  const handleSubmit = (dataItem: any) => {
    props.onDismissError?.()
    dataItem.employeeTypeId = dataItem.employeeTypeId?.value || dataItem.employeeTypeId;
    props.onUserSubmit(dataItem)
  }

  return (
    <Form
      initialValues={{
        mobilePhone: '', // ✅ This ensures mobilePhone is tracked
      }}
      onSubmit={handleSubmit}
      render={(formRenderProps) => (
        <FormElement style={{ padding: '1rem', marginBottom: '5rem' }}>
          <fieldset className={'k-form-fieldset'}>
            <div className='form__subtitle'>
              Add user details:
              <button
                className='form__reset__button'
                onClick={formRenderProps.onFormReset}
              >
                Clear fields
              </button>
            </div>

            {error && (
              <div
                role='alert'
                style={{
                  margin: '0.5rem 0 1rem',
                  padding: '0.75rem 1rem',
                  borderRadius: '6px',
                  background: '#fdecea',
                  border: '1px solid #f5c2c0',
                  color: '#8a1c14',
                  fontSize: '10pt',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                  <strong>{error.message}</strong>
                  <button
                    type='button'
                    onClick={props.onDismissError}
                    aria-label='Dismiss'
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0 }}
                  >
                    ✕
                  </button>
                </div>
                {error.details.length > 0 && (
                  <ul style={{ margin: '0.5rem 0 0', paddingLeft: '1.25rem' }}>
                    {error.details.map((detail) => (
                      <li key={detail}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            <Field
              name={'displayName'}
              component={FormInput}
              label={'Display name: '}
              placeholder={'Enter a name:'}
              validator={requiredValidator}
            />

            <Field
              name={'position'}
              component={FormInput}
              label={'Position: '}
              placeholder={'Enter a position:'}
            />

            <Field
              name={'hourlyRate'}
              component={FormNumericTextBox}
              label={'Hourly rate: '}
              placeholder={'Enter an hourly rate:'}
            />

                <Field
                    data={employeeTypes}
                    name={'employeeTypeId'}
                    component={FormDropDownList}
                    label={'Type *:'}
                    required
                    // defaultItem={formState.primaryContact ? { text: formState.primaryContact.title, value: formState.primaryContact.titleId } : { text: '', value: 0 }}
                    onChange={(e) => {
                      setSelectedEmployeeType(e.value.value)
                    }}
                />

            <Field
              name={'email'}
              component={FormInput}
              label={'Email: '}
              placeholder={'Enter an email:'}
              validator={emailValidator}
            />

            <Field
              name={'mobilePhone'}
              component={FormInput}
              label={'Mobile Phone: '}
              placeholder={'Enter a mobile number:'}
              validator={mobilePhoneValidator}
              validationMessage="Enter a valid mobile phone number"
            />

            <Field
              name={'password'}
              component={FormTextBoxPassword}
              label={'Password: '}
              onChange={(e: any) => setPassword(e.value)}
              validator={passwordValidator}
              type={'password'}
              passMatch={passMatch}
            />

            <Field
              name={'confirmPassword'}
              component={FormTextBoxPassword}
              label={`Confirm password: `}
              onChange={(e: any) => setConfirmPassword(e.value)}
              validator={passwordValidator}
              type={'password'}
              passLabel={passLabel}
              passMatch={passMatch}
            />

            <Field
              name={'subcontractor'}
              component={FormSwitch}
              label={'Subcontractor: '}
              value={subcontractorValue}
              defaultValue={false}
              onChange={handleSwitchContractor}
            />

            {/* Only an administrator can make someone an administrator. */}
            {props.canGrantAdmin && (
              <Field
                name={'adminRole'}
                component={FormSwitch}
                label={'Admin: '}
                value={subcontractorValue}
                defaultValue={false}
                onChange={handleSwitchContractor}
              />
            )}

          </fieldset>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              bottom: 0,
              left: 0,
              width: '100%',
              padding: '1rem 2rem 1rem 2rem',
              position: 'absolute',
              zIndex: '10000',
            }}
          >
            <Button
              type={'submit'}
              disabled={!allowSubmit || !formRenderProps.allowSubmit}
              style={{
                width: '100%',
                marginTop: '0.5rem',
                height: '3rem',
                backgroundColor: 'rgb(174 199 65)',
                color: 'rgb(71 83 21)',
                border: 0,
                borderRadius: '0.3rem',
              }}
            >
              Add user
            </Button>
          </div>
        </FormElement>
      )}
    />
  )
}

export default AddUserForm
